/**
 * Bridge Domain identities to the existing shared navigation state. The two
 * original recording adapters still use ContextMode; a record link must select
 * exactly the same state as their header tabs, including after session restore.
 * This is navigation compatibility, not a different Domain configuration model.
 */
export function resolveDomainSelection(domain) {
  const id = domain?.id || domain?.name;
  if (id === 'discipline') return { mode: 'mention', activeDomain: null };
  if (id === 'recognition') return { mode: 'recognition', activeDomain: null };
  return { mode: null, activeDomain: domain || null };
}

export function applyDomainSelection(domain, { schoolId, setMode, setActiveDomain }) {
  const selection = resolveDomainSelection(domain);
  if (selection.mode) setMode(selection.mode);
  setActiveDomain(selection.activeDomain, schoolId);
}
